import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TweetField from 'pages/widgets/form/tweet-input'
import PromotedOnlyCheckboxField from 'pages/widgets/form/promoted-only-checkbox/'
import MediaUploadModal from 'pages/widgets/form/media-upload'
import OverlayPreviewModal from './overlay-preview'
export class UploadWithButton extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      show: false,
      showPreview: false
    }

    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.showMediaPreview = this.showMediaPreview.bind(this)
    this.closeMediaPreview = this.closeMediaPreview.bind(this)
  }

  handleShow () {
    this.setState({ show: true })
  }

  handleClose () {
    this.setState({ show: false })
  }

  showMediaPreview () {
    this.setState({ showPreview: true })
  }

  closeMediaPreview () {
    this.setState({ showPreview: false })
  }

  render () {
    const { value, onChange } = this.props.input

    return (
      <div>
        <div className='col-xs-12'>
          <div className='row'>
            <button
              type='button'
              id='br-overlay-upload-input'
              className='btn green-haze'
              onClick={this.handleShow}
              disabled={this.props.overlayMediaId}
            >
              <i className='fa fa-image' />
              Upload Overlay
              {this.props.overlayMediaId ? (
                <i
                  style={{ marginLeft: '8px', marginRight: '0' }}
                  className='fa fa-check'
                />
              ) : null}
            </button>
          </div>

          <div className='row'>
            <button
              type='button'
              id='br-overlay-upload-input'
              className='btn green-haze-reverse'
              onClick={this.showMediaPreview}
              disabled={!this.props.overlayMediaId}
            >
              <i className='fa fa-eye' />
              Preview Overlay
            </button>
          </div>
        </div>

        <OverlayPreviewModal
          id={this.props.overlayMediaId}
          close={this.closeMediaPreview}
          showPreview={this.state.showPreview}
          actionType={`${this.props.overlayType}`}
        />

        <MediaUploadModal
          showModal={this.state.show}
          hideModal={this.handleClose}
          onChange={onChange}
          value={value}
          actionType={`${this.props.overlayType}`}
        />
      </div>
    )
  }
}

UploadWithButton.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  input: PropTypes.any,
  overlayMediaId: PropTypes.array,
  overlayType: PropTypes.string
}

export class Overlay extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      overlayType: props.overlayType,
      overlayMediaId: props.overlayMediaId
    }
  }

  render () {
    return (
      <div className='row'>
        <div className='br-has-checkbox col-sm-12'>
          <TweetField
            messageName={`${this.props.name}.message`}
            urlName={`${this.props.name}.attachmentUrl`}
            cardUriName={`${this.props.name}.cardUri`}
            isTweet
            isOverlay
          />
          <PromotedOnlyCheckboxField name={this.props.name} />
        </div>
        <div className='col-sm-12'>
          <p style={{ fontWeight: 600, color: '#6F6F6F' }}>Overlay options</p>
          <Field
            component={UploadWithButton}
            name={`${this.props.name}.overlayMediaId`}
            format={value => value || []}
            overlayMediaId={this.props.overlayMediaId}
            overlayType={this.props.overlayType}
          />
        </div>
      </div>
    )
  }
}

Overlay.propTypes = {
  name: PropTypes.string,
  overlayType: PropTypes.string,
  overlayMediaId: PropTypes.array
}

export default Overlay



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/send-overlay/overlay-attachments/components/overlay.js